// Bilingual content — French (fr) and English (en).
export const translations = {
  fr: {
    nav: {
      home: "Accueil",
      about: "À propos",
      services: "Services",
      contact: "Contact",
      callUs: "Nous appeler",
    },
    company: {
      tagline: "Conseil financier & accompagnement des entreprises",
      eyebrow: "Cabinet de conseil — Dakar, Sénégal",
      valueProp:
        "Votre partenaire en ingénierie financière, pilotage de la performance et mobilisation de ressources.",
      intro:
        "DS EXPERT SUARL est un cabinet sénégalais de conseil financier et d'accompagnement des entreprises, immatriculé à Dakar en 2019. Nous mettons au service des dirigeants, promoteurs de projets et institutions une expertise de plus de 20 années acquise dans la gestion financière, la modélisation économique, la mobilisation de financements internationaux, le pilotage de la performance et le développement commercial.",
      approach:
        "Notre approche conjugue rigueur méthodologique, vision pan-africaine et standards internationaux pour transformer vos enjeux financiers et stratégiques en leviers de croissance durable.",
    },
    stats: [
      { value: "20+", label: "années d'expérience" },
      { value: "40 Mds", label: "FCFA mobilisés auprès de bailleurs" },
      { value: "7", label: "domaines d'expertise" },
      { value: "100+ Mds", label: "FCFA de flux supervisés" },
    ],
    services: {
      eyebrow: "Nos domaines d'intervention",
      pageTitle: "8 domaines d'expertise à votre service",
      subtitle:
        "Une offre intégrée couvrant le cycle complet de l'entreprise — finance, stratégie, opérations et développement commercial.",
      items: [
        {
          title: "Conseil financier & stratégique",
          description:
            "Business plans, modèles économiques, études de viabilité, analyse de rentabilité, arbitrages stratégiques.",
        },
        {
          title: "Mobilisation de ressources",
          description:
            "Structuration de projets, préparation des dossiers bailleurs (SFI, Banque mondiale, AFD, BEI, BDEAC), PPP.",
        },
        {
          title: "Pilotage & contrôle de gestion",
          description:
            "Élaboration et suivi budgétaire, reporting stratégique, tableaux de bord et KPIs, optimisation des performances.",
        },
        {
          title: "Comptabilité, fiscalité & trésorerie",
          description:
            "Tenue comptable SYSCOHADA, conformité fiscale (DGI, IPRES, CSS), pilotage et optimisation de la trésorerie.",
        },
        {
          title: "Modélisation financière avancée",
          description:
            "Modèles Excel/VBA sur mesure, analyse de scénarios, évaluation d'entreprises, outils de pilotage dynamique.",
        },
        {
          title: "Digitalisation financière",
          description:
            "Digitalisation des fonctions finance et comptabilité : QuickBooks, ERP financiers, automatisation des reportings et tableaux de bord interactifs.",
        },
        {
          title: "Marketing & développement commercial",
          description:
            "Études de marché, stratégies marketing, plans d'activation terrain, développement commercial, coordination d'évènements promotionnels.",
        },
        {
          title: "Missions sur-mesure",
          description:
            "Vous avez un besoin spécifique non listé ? Nous structurons des missions ad hoc combinant nos expertises.",
        },
      ],
    },
    reasons: {
      eyebrow: "Pourquoi nous choisir",
      title: "Cinq raisons de nous faire confiance",
      items: [
        {
          title: "Expertise sénior",
          description:
            "Plus de 20 ans dans la finance, la comptabilité et le pilotage de la performance, dans des environnements multi-pays.",
        },
        {
          title: "Réseau bailleurs",
          description:
            "Interactions éprouvées avec SFI, Banque mondiale, AFD, BEI et BDEAC pour la structuration de financements complexes.",
        },
        {
          title: "Approche sur-mesure",
          description:
            "Solutions adaptées à la taille, au secteur et aux contraintes propres à chaque client : PME, projets, institutions.",
        },
        {
          title: "Outils modernes",
          description:
            "Maîtrise d'Excel/VBA avancé, QuickBooks, Oracle E-Business Suite et autres ERP financiers de référence.",
        },
        {
          title: "Standards internationaux",
          description:
            "Rigueur méthodologique alignée sur les meilleures pratiques de gouvernance financière internationales.",
        },
      ],
    },
    founder: {
      role: "Fondateur & Directeur Général — Expert financier sénior",
      quote:
        "Plus de 20 ans d'expérience en analyse, modélisation et ingénierie financière, acquise dans des environnements internationaux exigeants (ASECNA, multinationales) et auprès des grands bailleurs (SFI, Banque mondiale, AFD, BEI, BDEAC).",
      formationLabel: "Formation",
      parcoursLabel: "Parcours",
      formation: [
        "Master en Finance et Gestion Publiques (2003)",
        "Baccalauréat ès Sciences de Gestion — Comptabilité et Gestion Financière (1998)",
      ],
      parcours: [
        { period: "2022 →", title: "Arcadia Holding / 22BET", detail: "Senior Accountant" },
        {
          period: "2019 →",
          title: "DS EXPERT SUARL",
          detail: "Fondateur & Directeur Général",
        },
        {
          period: "1998 — 2018",
          title: "ASECNA",
          detail:
            "Responsable Budget d'investissements, Planification financière et Études financières",
        },
      ],
    },
    home: {
      heroServicesBtn: "Nos domaines d'expertise",
      heroAboutBtn: "Découvrir le cabinet",
      whoEyebrow: "Qui sommes-nous ?",
      whoTitle:
        "Un cabinet de conseil financier ancré à Dakar, tourné vers l'Afrique.",
      introLink: "En savoir plus sur DS EXPERT",
      expertiseTitle: "7 pôles d'expertise à votre service",
      allServicesLink: "Voir les 8 domaines d'expertise",
    },
    cta: {
      eyebrow: "Prenons contact",
      title: "Discutons de vos enjeux — un premier échange est sans engagement.",
      text: "Que vous soyez dirigeant, promoteur de projet ou institution, nous structurons la réponse financière adaptée à vos ambitions.",
      contactBtn: "Nous contacter",
    },
    about: {
      heroTitle: "À propos de DS EXPERT",
      storyEyebrow: "Notre histoire",
      storyTitle:
        "Rigueur méthodologique, vision pan-africaine, standards internationaux.",
      founderEyebrow: "Notre fondateur",
      founderTitle: "Une expertise sénior éprouvée",
      legalEyebrow: "Informations légales",
      legalLabels: { rccm: "RCCM", ninea: "NINEA", capital: "Capital social" },
    },
    contact: {
      heroTitle: "Discutons de vos enjeux",
      heroText:
        "Un premier échange est sans engagement. Contactez DS EXPERT par téléphone ou par email — nous vous répondons rapidement.",
      coordsEyebrow: "Nos coordonnées",
      coordsTitle: "Restons en contact",
      labels: {
        address: "Adresse",
        phone: "Téléphone",
        email: "Email",
        availability: "Disponibilité",
      },
      availabilityValue: "Du lundi au vendredi, 9h — 18h (GMT)",
      form: {
        eyebrow: "Écrivez-nous",
        title: "Envoyez-nous un message",
        nom: "Nom",
        prenom: "Prénom",
        entreprise: "Entreprise",
        entrepriseHint: "(optionnel)",
        email: "Email",
        objet: "Objet",
        message: "Message",
        submit: "Envoyer le message",
        sending: "Envoi en cours…",
        successTitle: "Message envoyé !",
        success: "Merci, nous avons bien reçu votre message et vous répondrons rapidement.",
        error: "Une erreur est survenue lors de l'envoi. Veuillez réessayer ou nous écrire directement.",
        rateLimited: "Trop de messages envoyés. Merci de réessayer dans quelques minutes.",
        required: "Ce champ est obligatoire.",
        invalidEmail: "Veuillez saisir une adresse email valide.",
      },
    },
    footer: {
      blurb:
        "Ingénierie financière, pilotage de la performance et mobilisation de ressources au service des entreprises et institutions.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "Tous droits réservés.",
    },
  },

  en: {
    nav: {
      home: "Home",
      about: "About",
      services: "Services",
      contact: "Contact",
      callUs: "Call us",
    },
    company: {
      tagline: "Financial advisory & business support",
      eyebrow: "Advisory firm — Dakar, Senegal",
      valueProp:
        "Your partner in financial engineering, performance management and resource mobilization.",
      intro:
        "DS EXPERT SUARL is a Senegalese financial advisory and business support firm, registered in Dakar in 2019. We place at the service of executives, project promoters and institutions more than 20 years of expertise acquired in financial management, economic modelling, the mobilization of international financing, performance management and business development.",
      approach:
        "Our approach combines methodological rigour, a pan-African vision and international standards to turn your financial and strategic challenges into levers for sustainable growth.",
    },
    stats: [
      { value: "20+", label: "years of experience" },
      { value: "40 Bn", label: "FCFA mobilized from donors" },
      { value: "7", label: "areas of expertise" },
      { value: "100+ Bn", label: "FCFA of flows supervised" },
    ],
    services: {
      eyebrow: "Our areas of intervention",
      pageTitle: "8 areas of expertise at your service",
      subtitle:
        "An integrated offering covering the company's full cycle — finance, strategy, operations and business development.",
      items: [
        {
          title: "Financial & strategic advisory",
          description:
            "Business plans, economic models, feasibility studies, profitability analysis, strategic trade-offs.",
        },
        {
          title: "Resource mobilization",
          description:
            "Project structuring, preparation of donor files (IFC, World Bank, AFD, EIB, BDEAC), PPPs.",
        },
        {
          title: "Management control & steering",
          description:
            "Budget preparation and monitoring, strategic reporting, dashboards and KPIs, performance optimization.",
        },
        {
          title: "Accounting, tax & treasury",
          description:
            "SYSCOHADA bookkeeping, tax compliance (DGI, IPRES, CSS), treasury steering and optimization.",
        },
        {
          title: "Advanced financial modelling",
          description:
            "Custom Excel/VBA models, scenario analysis, company valuation, dynamic steering tools.",
        },
        {
          title: "Financial digitalization",
          description:
            "Digitalization of finance and accounting functions: QuickBooks, financial ERPs, reporting automation and interactive dashboards.",
        },
        {
          title: "Marketing & business development",
          description:
            "Market research, marketing strategies, field activation plans, business development, coordination of promotional events.",
        },
        {
          title: "Tailor-made assignments",
          description:
            "Have a specific need not listed here? We structure ad hoc assignments combining our areas of expertise.",
        },
      ],
    },
    reasons: {
      eyebrow: "Why choose us",
      title: "Five reasons to trust us",
      items: [
        {
          title: "Senior expertise",
          description:
            "Over 20 years in finance, accounting and performance management, across multi-country environments.",
        },
        {
          title: "Donor network",
          description:
            "Proven interactions with IFC, World Bank, AFD, EIB and BDEAC for structuring complex financing.",
        },
        {
          title: "Tailor-made approach",
          description:
            "Solutions adapted to the size, sector and specific constraints of each client: SMEs, projects, institutions.",
        },
        {
          title: "Modern tools",
          description:
            "Mastery of advanced Excel/VBA, QuickBooks, Oracle E-Business Suite and other leading financial ERPs.",
        },
        {
          title: "International standards",
          description:
            "Methodological rigour aligned with international best practices in financial governance.",
        },
      ],
    },
    founder: {
      role: "Founder & Managing Director — Senior financial expert",
      quote:
        "Over 20 years of experience in analysis, modelling and financial engineering, acquired in demanding international environments (ASECNA, multinationals) and with major donors (IFC, World Bank, AFD, EIB, BDEAC).",
      formationLabel: "Education",
      parcoursLabel: "Career",
      formation: [
        "Master's in Public Finance and Management (2003)",
        "Bachelor of Management Sciences — Accounting and Financial Management (1998)",
      ],
      parcours: [
        { period: "2022 →", title: "Arcadia Holding / 22BET", detail: "Senior Accountant" },
        {
          period: "2019 →",
          title: "DS EXPERT SUARL",
          detail: "Founder & Managing Director",
        },
        {
          period: "1998 — 2018",
          title: "ASECNA",
          detail:
            "Head of Investment Budget, Financial Planning and Financial Studies",
        },
      ],
    },
    home: {
      heroServicesBtn: "Our areas of expertise",
      heroAboutBtn: "Discover the firm",
      whoEyebrow: "Who we are",
      whoTitle: "A financial advisory firm rooted in Dakar, focused on Africa.",
      introLink: "Learn more about DS EXPERT",
      expertiseTitle: "7 areas of expertise at your service",
      allServicesLink: "See all 8 areas of expertise",
    },
    cta: {
      eyebrow: "Get in touch",
      title: "Let's discuss your challenges — a first conversation is free of commitment.",
      text: "Whether you are an executive, project promoter or institution, we structure the financial response tailored to your ambitions.",
      contactBtn: "Contact us",
    },
    about: {
      heroTitle: "About DS EXPERT",
      storyEyebrow: "Our story",
      storyTitle:
        "Methodological rigour, pan-African vision, international standards.",
      founderEyebrow: "Our founder",
      founderTitle: "Proven senior expertise",
      legalEyebrow: "Legal information",
      legalLabels: { rccm: "RCCM", ninea: "NINEA", capital: "Share capital" },
    },
    contact: {
      heroTitle: "Let's discuss your challenges",
      heroText:
        "A first conversation is free of commitment. Contact DS EXPERT by phone or email — we'll get back to you quickly.",
      coordsEyebrow: "Our contact details",
      coordsTitle: "Let's stay in touch",
      labels: {
        address: "Address",
        phone: "Phone",
        email: "Email",
        availability: "Availability",
      },
      availabilityValue: "Monday to Friday, 9am — 6pm (GMT)",
      form: {
        eyebrow: "Write to us",
        title: "Send us a message",
        nom: "Last name",
        prenom: "First name",
        entreprise: "Company",
        entrepriseHint: "(optional)",
        email: "Email",
        objet: "Subject",
        message: "Message",
        submit: "Send message",
        sending: "Sending…",
        successTitle: "Message sent!",
        success: "Thank you, we have received your message and will get back to you shortly.",
        error: "Something went wrong while sending. Please try again or email us directly.",
        rateLimited: "Too many messages sent. Please try again in a few minutes.",
        required: "This field is required.",
        invalidEmail: "Please enter a valid email address.",
      },
    },
    footer: {
      blurb:
        "Financial engineering, performance management and resource mobilization for businesses and institutions.",
      navTitle: "Navigation",
      contactTitle: "Contact",
      rights: "All rights reserved.",
    },
  },
};
